import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n';
import { PriceFileCategoryBadgeModule } from '../price-file-category-badge/price-file-category-badge.module';
import { PriceFileCategoryListComponent } from './price-file-category-list.component';

@NgModule({
  declarations: [PriceFileCategoryListComponent],
  imports: [CommonModule, I18nModule, PriceFileCategoryBadgeModule, NzIconModule],
  exports: [PriceFileCategoryListComponent],
})
export class PriceFileCategoryListModule {}
